module.exports = __webpack_public_path__ + "img/gear.02fea8a6.svg";